import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';

@Component({
  selector: 'app-search-v1',
  templateUrl: './SearchV1.component.html',
  styleUrls: ['./SearchV1.component.scss']
})
export class SearchComponent implements OnInit {

  @Input() placeholder: string;

  public form: UntypedFormGroup;

  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
  ) {
  }

  ngOnInit() {
    this.form = this.fb.group({
      q: ['', Validators.required]
    });
  }

  onSubmit() {
    this.router.navigate(['/data-catalogue'], {queryParams: {q: this.form.value.q}});
  }
}
